import { Navigate, Route, Routes } from "react-router"
import { LoginComponent } from "./login/LoginComponent"
import { ForgotPasswordComponent } from "./ForgotPasswordComponent"
import { ResetPasswordComponent } from "./ResetPasswordComponent"

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Navigate to="login" replace/>} />
      <Route path="login" element={<LoginComponent />} />
      <Route path="forgot-password" element={<ForgotPasswordComponent />} />
      <Route path="reset-password" element={<ResetPasswordComponent />} />
    </Routes>
  )
}